import { Component, Input, OnInit } from '@angular/core';
import { Voucher } from 'models/vouchers/voucher';

@Component({
  selector: 'ngx-voucher-card',
  templateUrl: './voucher-card.component.html',
  styleUrls: ['./voucher-card.component.scss'],
})
export class VoucherCardComponent implements OnInit {
  @Input()
  voucher: Voucher;

  constructor() {}

  ngOnInit(): void {}
}
